"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./margin-shorthand"), exports);
tslib_1.__exportStar(require("./padding-shorthand"), exports);
tslib_1.__exportStar(require("./border-radius-shorthand"), exports);
tslib_1.__exportStar(require("./border-shorthand"), exports);
tslib_1.__exportStar(require("./outline-shorthand"), exports);
tslib_1.__exportStar(require("./border-image-shorthand"), exports);
tslib_1.__exportStar(require("./background-shorthand"), exports);
tslib_1.__exportStar(require("./font-shorthand"), exports);
tslib_1.__exportStar(require("./place-content-shorthand"), exports);
tslib_1.__exportStar(require("./place-items-shorthand"), exports);
tslib_1.__exportStar(require("./flex-shorthand"), exports);
tslib_1.__exportStar(require("./flex-flow-shorthand"), exports);
tslib_1.__exportStar(require("./gap-shorthand"), exports);
tslib_1.__exportStar(require("./grid-gap-shorthand"), exports);
tslib_1.__exportStar(require("./grid-axis-shorthand"), exports);
tslib_1.__exportStar(require("./grid-template-shorthand"), exports);
tslib_1.__exportStar(require("./grid-shorthand"), exports);
tslib_1.__exportStar(require("./overflow-shorthand"), exports);
tslib_1.__exportStar(require("./text-decoration-shorthand"), exports);
tslib_1.__exportStar(require("./list-style-shorthand"), exports);
//# sourceMappingURL=index.js.map